export const PRODUCTION_API_BASE_URL = "https://starliveapi.xyhy.live/user/api"

const configuredApiBaseUrl = String(process.env.VUE_APP_API_BASE_URL || "").trim()

export const API_BASE_URL = (configuredApiBaseUrl || (
  process.env.NODE_ENV === "production"
    ? PRODUCTION_API_BASE_URL
    : "/user/api"
)).replace(/\/$/, "")
